export default ({ theme }) => ({
    fontSize: '1.1rem',
    lineHeight: 1.5,
    color: theme.colors.greyAddress,
    padding: 0,
    '&:first-of-type': {
        fontWeight: 700,
    },
});
